// =============================================================================
// Solmart — keep the language switcher off order item names.
// =============================================================================
// The parent theme's thank-you and my-account order templates print the item
// name themselves: no WooCommerce name filter, and no class we can hook from
// PHP. On the Korean site GTranslate would translate that name, and the result
// would sit directly above the Korean name we print from the product meta — the
// same product named twice. Every product has a Korean name, so holding the
// name back never leaves the row without one.
//
// GTranslate translates the page in the browser, so marking the elements from
// JS before it runs is enough. These pages are server-rendered and never
// re-render their item list, so a single pass at boot covers them.
// =============================================================================

const SELECTORS = [".az-thankyou__item-name", ".ma__vo-item-name"];

export default function initNotranslateNames() {
	document.querySelectorAll(SELECTORS.join(",")).forEach((el) => {
		el.classList.add("notranslate");
		el.setAttribute("translate", "no");
	});
}
